import React from 'react'
import PropTypes from 'prop-types'
import PaypalPayLater from '../paypal-pay-later'
import KlarnaPayLater from '../klarna-pay-later'
import usePayLater from './usePayLater'

const PayLater = ({
    amount,
    currency,
    klarnaPlacement,
    paypalPlacement,
    uspPayLaterShowAll: showAll
}) => {
    const {isPaypalEnabled, isKlarnaEnabled} = usePayLater({
        amount,
        currency,
        paypalPlacement,
        klarnaPlacement
    })

    if (showAll && isPaypalEnabled && isKlarnaEnabled) {
        return (
            <>
                <PaypalPayLater amount={amount} currency={currency} placement={paypalPlacement} />
                <KlarnaPayLater amount={amount} placement={klarnaPlacement} />
            </>
        )
    } else if (isPaypalEnabled) {
        return <PaypalPayLater amount={amount} currency={currency} placement={paypalPlacement} />
    } else if (isKlarnaEnabled) {
        return <KlarnaPayLater amount={amount} placement={klarnaPlacement} />
    } else {
        return null
    }
}

PayLater.propTypes = {
    amount: PropTypes.number,
    currency: PropTypes.string,
    klarnaPlacement: PropTypes.string,
    paypalPlacement: PropTypes.string,
    uspPayLaterShowAll: PropTypes.bool
}

export default PayLater
